import { FormType } from '../../../shared/models/form';

export const validateAdults = (value: number, formValues: FormType): string => {
  if (
    (value < 2 || value <= formValues.infants) &&
    value + formValues.children + formValues.infants > 8
  ) {
    return 'minmax';
  }
  if (value < 2 || value <= formValues.infants) {
    return 'min';
  }
  if (value + formValues.children + formValues.infants > 8) {
    return 'max';
  }
  return '';
};

export const validateChildren = (value: number, formValues: FormType): string => {
  if (value < 1 && value + formValues.adults + formValues.infants > 8) {
    return 'minmax';
  }
  if (value < 1) {
    return 'min';
  }
  if (value + formValues.adults + formValues.infants > 8) {
    return 'max';
  }
  return '';
};

export const validateInfants = (value: number, formValues: FormType): string => {
  if (
    value < 1 &&
    (value + formValues.adults + formValues.children > 8 || value >= formValues.adults)
  ) {
    return 'minmax';
  }
  if (value < 1) {
    return 'min';
  }
  if (value + formValues.adults + formValues.children > 8 || value >= formValues.adults) {
    return 'max';
  }
  return '';
};
